import { registerGsapPlugins, ScrollTrigger } from './gsap/setup';
import SmoothScroll from './singleton/SmoothScroll';
import ScrollVisibility from './animations/ScrollVisibility';
import { initHomeColorChange } from './animations/HomeColorChange';
import { initFeatured } from './animations/Featured';
import { initBrand } from './animations/Brand';
import { initFooter } from './animations/Footer';
import { initLeftovers } from './animations/Leftovers';
import { initHeroMotionTrail, destroyHeroMotionTrail } from './animations/HeroMotionTrail';
import { initHeroScrollGrid, destroyHeroScrollGrid } from './animations/HeroScrollGrid';
import { initProject } from './animations/Project';
import { initStickers } from './animations/Stickers';
import { destroyMarquee, initMarquee } from './components/Marquee';
import { destroyAccordion, initAccordion } from './components/Accordion';
import { destroyServicesNav, initServicesNav } from './animations/ServicesNav';
import Header from './components/Header';
import Preloader from './components/Preloader';
import BarbaTransitions from './components/BarbaTransitions';

class Website {
  constructor() {
    registerGsapPlugins();
    SmoothScroll;

    this.header = new Header();
    this.scrollVisibility = new ScrollVisibility();

    this.preloader = new Preloader({
      onIntroComplete: () => this.initPage(),
    });

    this.barba = new BarbaTransitions({
      preloader: this.preloader,
      onPageReady: () => this.finishPageNavigation(),
      onBeforeLeave: (data) => this.handleBeforeLeave(data),
    });

    this.barba.init();
  }

  initPage() {
    this.header.refreshRefs();
    this.header.bindEvents();

    initHomeColorChange();
    initStickers();
    initFeatured();
    initFooter(this.header.get$header());
    initBrand();
    initLeftovers();
    initHeroMotionTrail();
    initHeroScrollGrid();
    initProject();
    initMarquee();
    initAccordion();
    initServicesNav();

    this.scrollVisibility.observe();
    SmoothScroll.refresh();
  }

  finishPageNavigation() {
    SmoothScroll.enableScrolling();
    SmoothScroll.scrollToTop({ immediate: true });
    this.initPage();
  }

  handleBeforeLeave(data) {
    destroyMarquee();
    destroyAccordion();
    destroyServicesNav();
    destroyHeroMotionTrail();
    destroyHeroScrollGrid();
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

    const nextHtml = data.next.html;
    const responseBody = nextHtml.replace(
      /(<\/?)body( .+?)?>/gi,
      '$1notbody$2>',
      nextHtml,
    );
    const bodyClasses = $(responseBody).filter('notbody').attr('class');
    $('body').attr('class', bodyClasses || '');
  }
}

$(document).ready(() => {
  new Website();
});
